module.exports = __webpack_public_path__ + "img/begin_show.27f76a39.png";